import { render, staticRenderFns } from "./IntegracaoModule.vue?vue&type=template&id=41e249b5"
import script from "./IntegracaoModule.vue?vue&type=script&lang=js"
export * from "./IntegracaoModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports